import React from "react"
import { Button } from "@/components/ui/button"
import { Settings } from "lucide-react"
import { ApplicationDeadlineSettingsModal } from "./ApplicationDeadlineSettingsModal"

export function ApplicationSettingsButton() {
    const [open, setOpen] = React.useState(false)

    return (
        <>
            <Button
                variant="ghost"
                onClick={() => setOpen(true)}
                className="flex items-center gap-2 text-gray-500"
                size="sm"
                title="Application Settings"
            >
                <Settings className="h-4 w-4" /> Settings
            </Button>
            <ApplicationDeadlineSettingsModal
                open={open}
                onOpenChange={setOpen}
            />
        </>
    )
}
